<script lang="ts" setup>

defineProps({
  title: {
    type: String,
    default: null,
  },

  message: {
    type: String,
    default: null,
  },
});
</script>

<template>
  <div class="ml-3 w-0 flex-1 pt-0.5">
    <p
      v-if="title"
      data-test="toast-title"
      class="text-sm font-medium text-slate-900 mb-1"
    >
      {{ title }}
    </p>

    <p
      v-if="message"
      data-test="toast-message"
      class="text-sm text-slate-500"
    >
      {{ message }}
    </p>
  </div>
</template>
